   
   <template>
  <div>
    <v-app-bar color="primary" dark>
      <div class="d-flex align-center">
        <v-img
          alt="SmartLogo"
          class="clickable shrink mr-2"
          contain
          :src="getImgUrl"
          transition="scale-transition"
          :width="isMobile ? '50px' : '170px'"
          @click="goBack"
        />
      </div>

      <v-spacer></v-spacer>
      <v-menu bottom left offset-y transition="slide-y-transition">
        <template v-slot:activator="{ attrs, on }">
          <v-btn @click="openNotify" text v-bind="attrs" v-on="on">
            <span v-if="!isMobile" class="mr-4">Notifications</span>
            <v-icon color="tertiary"> mdi-email-fast </v-icon>
          </v-btn>
          <v-btn @click="openFriends" text v-bind="attrs" v-on="on">
            <v-badge color="success" :value="getFriendsCount" :content="getFriendsCount" overlap>
              <span v-if="!isMobile" class="mr-4">Friends</span>
              <v-icon color="tertiary"> mdi-account-multiple </v-icon>
            </v-badge>
          </v-btn>
        </template>
      </v-menu>
      <v-spacer></v-spacer>
      <v-btn @click="logout()" text>
        <span v-if="!isMobile" class="mr-2">Logout</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <b-modal ref="FriendsList" hide-footer title="My friends">
      <div class="d-block text-center">
        <FriendsList></FriendsList>
        <v-btn text class="mt-5" color="#1E88E5" @click="hideFriends">Close</v-btn>
      </div>
    </b-modal>
    <b-modal ref="Notify" hide-footer hide-header-close title-tag="div" title-class="w-100 contents">
      <template #modal-title>
        <h5>Notification</h5>
        
        <v-spacer/>
        <v-btn text @click="openRecent" color="primary">Recent</v-btn>
      </template>
      <div class="d-block text-center">
        <Notify></Notify>
      </div>
    </b-modal>
    <b-modal ref="RecentNotify" size="xl" hide-footer title="Recent notification">
      <div class="d-block text-center">
        <RecentNotify></RecentNotify>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from "../api";
import FriendsList from "./FriendsList";
import Notify from "./Notify";
import RecentNotify from "./RecentNotify";

export default {
  name: "AppBar",
  components: {
    FriendsList,
    Notify,
    RecentNotify
  },
  computed: {
    getFriendsCount() {
      return this.$store.state.data ? this.$store.state.data.friends.filter(el => el.status == 'Request').length : 0;
    },
    isMobile() {
      return this.$vuetify.breakpoint.width < 676
    },
    getImgUrl() {
    var images = require.context('../../public/', false, /\.png$/)
    return images('./' + (this.isMobile ? 'pngmin' : 'png') + ".png")
    }
  },
  methods: {
    goBack() {
      this.$store.state.calendar = null;
      this.$store.state.isUpdate = true;
      this.$store.dispatch("updateData");
    },
    logout() {
      var me = this;
      api.logout(function (success, response) {
        if (success) {
          me.$notify({
            group: "app",
            type: "success",
            title: "Success",
            text: response.info,
            duration: 3000,
          });
          me.$router.push("/login");
          me.$store.state.lastUpdated = 1;
          clearTimeout(me.$store.timeout);
        }
      });
    },
    openFriends() {
      this.$refs.FriendsList.show();
    },
    hideFriends() {
      this.$refs.FriendsList.hide();
    },
    openNotify() {
      this.$refs.Notify.show();
    },
    hideNotify() {
      this.$refs.Notify.hide();
    },
    openRecent() {
      this.$refs.RecentNotify.show();
    },
    hideRecent() {
      this.$refs.RecentNotify.hide();
    }
  },
};
</script>
<style>
.clickable {
  cursor: pointer;
}
.contents {
  display: contents;
}
.primary--text {
  color: rgb(30, 136, 229) !important;
}
</style>